import { render, staticRenderFns } from "./MClose.vue?vue&type=template&id=a2bbebd8&scoped=true&"
import script from "./MClose.vue?vue&type=script&lang=js&"
export * from "./MClose.vue?vue&type=script&lang=js&"
import style0 from "./MClose.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./MClose.vue?vue&type=style&index=1&id=a2bbebd8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bbebd8",
  null
  
)

export default component.exports